export const HSBC_APP_LINK =
  "https://www.hsbc.co.in/ways-to-bank/mobile-banking/india-app/";
